import CreatePage from "./Create";
export default CreatePage;